var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultError',{attrs:{"details":{ statusCode: _vm.statusCode, message: _vm.message, title: _vm.message, icon: ['far', 'cloud'] }}})}
var staticRenderFns = []

export { render, staticRenderFns }